import React from 'react';

function CancelWarning({
  onClose,
  onImpersonate
}: {
  onClose: () => void;
  onImpersonate: () => void;
}) {
  return (
    <div className="custom-modal-container">
      <div className="max-w-md mx-auto bg-white rounded-2xl shadow p-6 ">
        <div className="flex items-center justify-center w-12 h-12 mx-auto rounded-full bg-red-500 text-white text-2xl">
          !
        </div>

        <h2 className="flex justify-center gap-4 font-extrabold text-lg my-[10px]">Alert</h2>

        <p className="flex flex-col items-center text-center gap-1 m-0">
          You need to Impersonate user and
          <br />
          Resume the user’s membership.
          <br />
          Once resumed, return to Hridaya
          <br />
          to cancel membership immediately.
        </p>

        <div className="flex justify-center pt-[5px]">
          <button
            className="bg-gray-200 text-black px-6 py-2 w-full rounded border border-gray-400 hover:bg-gray-300"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="bg-blue-600 text-white px-6 py-2 w-full rounded border border-blue-700"
            onClick={onImpersonate}
          >
            Impersonate
          </button>
        </div>
      </div>
    </div>
  );
}

export default CancelWarning;
